/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoAddVoyageInput = {
    clientMutationId?: string | null;
    name: string;
    vesselSlug: string;
    sourcePortCode?: string | null;
    destinationPortCode: string;
    shouldFetchEta: boolean;
    etd?: string | null;
    eta?: string | null;
};
export type VoyageAddMutationVariables = {
    input: infoAddVoyageInput;
};
export type VoyageAddMutationResponse = {
    readonly infoAddVoyage: {
        readonly voyage: {
            readonly slug: string;
        };
    } | null;
};
export type VoyageAddMutation = {
    readonly response: VoyageAddMutationResponse;
    readonly variables: VoyageAddMutationVariables;
};



/*
mutation VoyageAddMutation(
  $input: infoAddVoyageInput!
) {
  infoAddVoyage(input: $input) {
    voyage {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VoyageAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoAddVoyagePayload",
        "kind": "LinkedField",
        "name": "infoAddVoyage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Voyage",
            "kind": "LinkedField",
            "name": "voyage",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VoyageAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoAddVoyagePayload",
        "kind": "LinkedField",
        "name": "infoAddVoyage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Voyage",
            "kind": "LinkedField",
            "name": "voyage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c20fa230b80857db0360a5f7f1fb368",
    "id": null,
    "metadata": {},
    "name": "VoyageAddMutation",
    "operationKind": "mutation",
    "text": "mutation VoyageAddMutation(\n  $input: infoAddVoyageInput!\n) {\n  infoAddVoyage(input: $input) {\n    voyage {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '315fef0f0d6e6289b0ef4a41b66d29e9';
export default node;
